const specialCharactersRegex = /[^a-z0-9 ]/gi;
const whiteCharacterRegex = /\s+/g;

const nameCleanup = (name) =>
  name.toLowerCase().replace("-", " ").replace(specialCharactersRegex, "").replace(whiteCharacterRegex, "-");

export const normalizeId = (name, prefix = "") => `${prefix ? `${prefix}_` : ""}${nameCleanup(name)}`;
